import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Errors from "../components/Error";
import '@fortawesome/fontawesome-free/css/all.min.css';

function Error() {
  return (
    <>
      <Header />
      <Errors />
      <Footer />
    </>
  );
}

export default Error;